import React from "react";
import { moment, renderNumberGreaterThan100 } from "../../common/common";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";


import { IcCalendarSearch, IcStarRating, IcTotalTrip } from "../../common/svg";

import car_photo from "../../../static/images/upload/car_1.png";

const viewMode = {
	TRIPS: 0,
	HISTORY: 1,
	CS: 2 
};

const TripCSItem = ({ car, trip, group, isSD, mode }) => {

	return (
		<div className="item-car row">
			<div className="item-box">
				<div className="img-car">
						<div className="fix-img">
							<img
								loading="lazy"
								src={(group && group.photos) ? group.photos[0] : car_photo}
								alt={`Cho thuê xe tự lái ${car.name}`}
							/>
						</div>
	
				</div>
				<div className="desc-car">
			
					<div className="desc-name">
						<p>{car.name}</p>
					</div>
		
					<div className="desc-trip">
						<div className="desc-trip__item">
							<div className="wrap-svg">
								<IcCalendarSearch />
							</div>
							<p>Bắt đầu: {moment(trip.tripDateFrom).format("dddd, DD/MM/YYYY")}</p>
						</div>
						<div className="desc-trip__item">
							<div className="wrap-svg">
								<IcCalendarSearch />
							</div>
							<p>Kết thúc: {moment(trip.tripDateTo).format("dddd, DD/MM/YYYY")}</p>
						</div>
						{trip.priceSummary && <div className="desc-trip__item">
							<p>Thời gian thuê: {trip.priceSummary.totalMonths} tháng</p>
						</div>}
					</div>
					<div className="desc-name">
						<p>
							Tổng tiền:{" "}
							<NumberFormat
								value={trip.priceSummary ? trip.priceSummary.priceTotal : 0}
								displayType={"text"}
								thousandSeparator={" "}
								decimalSeparator={","}
								suffix="đ"
							/>
						
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TripCSItem;
